import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { AiOutlineGoogle } from 'react-icons/ai';
import { BsTwitter, BsInstagram } from 'react-icons/bs';
import Collapsible from 'react-collapsible';

const Sidebar = ({ show, handleClose }) => {
   const About = <a href="/">About Us</a>
   const Pages = <NavLink to="/">Pages </NavLink>
   const Services = <NavLink to="/services">Services </NavLink>
   const Projects = <NavLink to="/projects">Projects</NavLink>
   const Blog = <NavLink to="/blogSidebar">Blog</NavLink>
   return (
      <>

         <div className='side__bar'>
            <Offcanvas show={show} onHide={handleClose} placement='end'>
               <Offcanvas.Header closeButton>
                  {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
               </Offcanvas.Header>
               <Offcanvas.Body>


                  <Collapsible trigger={About} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                     <ul className="sidebar_sub_menu text-white mt-3">
                        <li><a target="_blank" href="https://www.neogrowth.in/about-us/" >Our Story</a></li>
                        <li><a target="_blank" href="https://www.neogrowth.in/board-of-directors/">Board Of Directors</a></li>
                        <li><a target="_blank" href="https://www.neogrowth.in/partner-2/">Our Partners</a></li>
                        <li><a target="_blank" href="https://www.neogrowth.in/leadership-team/">Leadership Team</a></li>
                        <li><a target="_blank" href="https://www.neogrowth.in/awards-recognitions/">Awards &#038; Recognitions</a></li>
                        <li><a target="_blank" href="https://www.neogrowth.in/corporate-brochure/">Corporate Brochure</a></li>
                     </ul>
                  </Collapsible>

                  <Collapsible trigger={Pages} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                     <ul className="sidebar_sub_menu text-white mt-3">
                        <li><NavLink to="/about">About</NavLink></li>
                        <li><NavLink to="/appointment">Appointment</NavLink></li>
                        <li><NavLink to="/pricing">Pricing</NavLink></li>
                        <li><NavLink to="/team">Team</NavLink></li>
                        <li><NavLink to="/teamDetails">Team Details</NavLink></li>
                        <li><NavLink to="/faq">Faq</NavLink></li>
                     </ul>
                  </Collapsible>

                  <Collapsible trigger={Services} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                     <ul className="sidebar_sub_menu text-white mt-3">
                        <li><NavLink to="/services">Services</NavLink></li>
                        <li><NavLink to="/servicesDetails">Services Details</NavLink></li>
                     </ul>
                  </Collapsible>

                  <Collapsible trigger={Projects} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                     <ul className="sidebar_sub_menu text-white mt-3">
                        <li><NavLink to="/projects">Projects</NavLink></li>
                        <li><NavLink to="/projectsDetails">Projects Details</NavLink></li>
                     </ul>
                  </Collapsible>

                  <Collapsible trigger={Blog} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                     <ul className="sidebar_sub_menu text-white mt-3">
                        <li><NavLink to="/blogSidebar">Blog Sidebar</NavLink></li>
                        <li><NavLink to="/blogDetails">Blog Details</NavLink></li>
                     </ul>
                  </Collapsible>

                  <div className='contact_nav text-white font-bold'>
                     <NavLink className="font-bold" to="/contact">Contact</NavLink>
                  </div>

                  <div className="fix">
                     <div className="side-info">
                        <div className="side-info-content">
                           <div className="tp-mobile-menu"></div>
                           <div className="contact-infos mb-30">
                              <div className="contact-list mb-30">
                                 <h4>Contact Info</h4>
                                 <ul>
                                    <li><i className="flaticon-pin"></i>802, 8th Floor, Tower A, Peninsula Business Park,Ganpatrao Kadam Marg, Lower Parel (West),Mumbai – 400013</li>
                                    <li><i className="flaticon-email"></i><a href="mailto:helpdesk@neogrowth.in">helpdesk@neogrowth.in</a></li>
                                    <li><i className="flaticon-phone-call"></i><a href="tel:18004195565">1800-419-5565</a></li>
                                 </ul>
                                 <div className="sidebar__menu--social">
                                    <a target="_blank" className="text-white" href="https://www.facebook.com/NeoGrowth-Credit-1663092290644997/"><i><FaFacebookF className='icon' /> </i></a>
                                    <a target="_blank" className="text-white" href="https://twitter.com/NeoGrowth_Loans"><i><BsTwitter className='icon' /> </i></a>
                                    <a target="_blank" className="text-white" href="https://in.linkedin.com/company/neogrowth-credit-pvt-ltd"><i><FaLinkedinIn className='icon' /> </i></a>
                                    <a target="_blank" className="text-white" href="https://www.youtube.com/channel/UC_ybb6PgsDpTDGMjM9MBwPA"><i><FaYoutube className='icon' /> </i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </Offcanvas.Body>
            </Offcanvas>
         </div>
      </>
   );
};

export default Sidebar;